import { StatisticDataItem } from "types/business/StatisticDataItem";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = StatisticDataItem[];

export const useDefaultObservableStatisticDataItemArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectStatisticDataItemArray extends BehaviorSubject<CurrentType> {}
